export default [
    { 
        name    : 'document', 
        groups  : [ 'mode', 'document' ], 
        items   : [ 'Source', '-', 'NewPage', 'Preview' ]
    },
    { 
        name    : 'clipboard', 
        groups  : [ 'clipboard', 'undo' ], 
        items   : [ 'Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo' ] 
    },
    { 
        name    : 'basicstyles', 
        groups  : [ 'basicstyles', 'cleanup' ], 
        items   : [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat' ]
    },
    { 
        name    : 'styles', 
        items   : [ 'Styles', 'Format', 'Font', 'FontSize' ] 
    },
    { 
        name    : 'colors', 
        items   : [ 'TextColor', 'BGColor' ] 
    },
    { 
        name    : 'tools', 
        items   : [ 'Maximize', 'ShowBlocks' ] 
    },
]